import React, { useState, Fragment } from "react"
import { MdClose } from "react-icons/md"
import { FaPlus } from "react-icons/fa"
import { AiFillPicture } from "react-icons/ai"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { FileUploaderWrapper, LightBox } from "components"
import classes from "./index.module.scss"

const ImageUploader = props => {
  const {
    values,
    onAdded,
    onRemoved,
    enableCrop,
    readOnly,
    isDeletable = false,
    aspectRatio,
    accountId,
    imageCategory,
    maxNumberOfUploads
  } = props

  const i18n = useTranslation()[1]

  const [photoIndex, setPhotoIndex] = useState(0)
  const [openGalleryPopup, setOpenGalleryPopup] = useState(false)

  const handleToggleLightBox = i => {
    setPhotoIndex(i)

    setOpenGalleryPopup(!openGalleryPopup)
  }

  const handleDeleteImage = (uploadedImage) => {
    onRemoved(uploadedImage)
  }

  const showFileInput =
    !readOnly &&
    !!isDeletable &&
    values.length < maxNumberOfUploads

  const imagesSlider = values.slice(0)

  const maxUpload =
    maxNumberOfUploads - values.length

  const removeMargin = maxUpload === 0 || readOnly

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["container"]}>
        {
          showFileInput &&
          <FileUploaderWrapper
            accountId={accountId}
            imageCategory={imageCategory}
            enableCrop={enableCrop}
            aspectRatio={aspectRatio}
            onUploadComplete={onAdded}
            maxNumberOfUploads={maxUpload}
          >
            <div className={classes["file-input"]}>
              <div className={classes["pic-icon"]}>
                <AiFillPicture size={20} />
                <FaPlus
                  className={clsx(
                    classes["pic-icon-plus"],
                    isLtr && classes["pic-icon-plus-ltr"]
                  )}
                />
              </div>
            </div>
          </FileUploaderWrapper>
        }

        <div
          className={clsx(
            classes["row"],
            isLtr && classes["row-ltr"],
            removeMargin && classes["remove-margin"],
            removeMargin && isLtr && classes["remove-margin-ltr"]
          )}
        >
          {imagesSlider.map((uploadedImage, index) =>
            <div
              key={uploadedImage}
              className={clsx(
                classes["image-container"],
                isLtr && classes["image-container-ltr"]
              )}
            >
              <img
                src={`${uploadedImage}?width=100&quality=80`}
                className={classes["image"]}
                onClick={() => handleToggleLightBox((values.length - 1) - index)}
                alt=""
              />
              {
                isDeletable &&
                <div
                  onClick={() => handleDeleteImage(uploadedImage)}
                  className={clsx(
                    classes["delete-icon"],
                    isLtr && classes["delete-icon-ltr"]
                  )}
                >
                  <MdClose />
                </div>
              }
            </div>
          )}
        </div>
      </div>

      <LightBox
        open={openGalleryPopup}
        index={photoIndex}
        close={() => setOpenGalleryPopup(false)}
        images={imagesSlider}
      />
    </Fragment>
  )
}

export default ImageUploader